<div class="model-selector-container">
  <ion-select
    class="model-selector-label"
    [label]="'AI_MODEL_SELECTOR.LABEL' | translate"
    label-placement="floating"
    [placeholder]="'AI_MODEL_SELECTOR.PLACEHOLDER' | translate"
    (ionChange)="handleChange($event)"
    interface="popover"
    [interfaceOptions]="{ header: ('AI_MODEL_SELECTOR.HEADER' | translate) }"
    [value]="criteriaList?.[0]?.id">
    <ion-select-option *ngFor="let criteria of criteriaList" [value]="criteria.id">
      {{criteria.name}}
    </ion-select-option>
  </ion-select>
</div>

